import {
  BUSINESS_TYPES_LOOKUP_RESPONSE,
  BUSINESS_VERIFICATION_STATUS_LOOKUP_RESPONSE,
  BUSINESS_VERIFICATION_TYPES_LOOKUP_RESPONSE,
  CATEGORIES_LOOKUP_RESPONSE,
  COMPANIES_LOOKUP_RESPONSE,
  COUNTRIES_LOOKUP_RESPONSE,
  EXPORTERS_LOOKUP_RESPONSE,
  PRICING_PLANS_LOOKUP_RESPONSE,
  ROLES_LOOKUP_RESPONSE,
  SUB_CATEGORIES_LOOKUP_RESPONSE,
  TRANSACTION_PAYMENT_REASONS_LOOKUP_RESPONSE,
  TRANSACTION_STATUS_LOOKUP_RESPONSE,
  VOUCHER_COMPANIES_LOOKUP_RESPONSE
} from "./types";

const INITIAL_STATE = {
  categories: {
    list: []
  },
  subCategories: {
    list: []
  },
  countries: {
    list: []
  },
  exporters: {
    list: []
  },
  companies: {
    list: []
  },
  businessVerificationTypes: {
    list: []
  },
  businessTypes: {
    list: []
  },
  businessVerificationStatus: {
    list: []
  },
  voucherCompanies: {
    list: []
  },
  roles: {
    list: []
  },
  transactionPaymentReasons: {
    list: []
  },
  transactionStatus: {
    list: []
  },
  pricingPlans: {
    list: []
  }
};

const lookups = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CATEGORIES_LOOKUP_RESPONSE:
      return {
        ...state,
        categories: {
          list: action.payload.list
        }
      };
    case SUB_CATEGORIES_LOOKUP_RESPONSE:
      return {
        ...state,
        subCategories: {
          list: action.payload.list
        }
      };
    case COUNTRIES_LOOKUP_RESPONSE:
      return {
        ...state,
        countries: {
          list: action.payload.list
        }
      };
    case EXPORTERS_LOOKUP_RESPONSE:
      return {
        ...state,
        exporters: {
          list: action.payload.list
        }
      };
    case COMPANIES_LOOKUP_RESPONSE:
      return {
        ...state,
        companies: {
          list: action.payload.list
        }
      };
    case BUSINESS_VERIFICATION_TYPES_LOOKUP_RESPONSE:
      return {
        ...state,
        businessVerificationTypes: {
          list: action.payload.list
        }
      };
    case BUSINESS_TYPES_LOOKUP_RESPONSE:
      return {
        ...state,
        businessTypes: {
          list: action.payload.list
        }
      };
    case BUSINESS_VERIFICATION_STATUS_LOOKUP_RESPONSE:
      return {
        ...state,
        businessVerificationStatus: {
          list: action.payload.list
        }
      };
    case VOUCHER_COMPANIES_LOOKUP_RESPONSE:
      return {
        ...state,
        voucherCompanies: {
          list: action.payload.list
        }
      };
    case TRANSACTION_PAYMENT_REASONS_LOOKUP_RESPONSE:
      return {
        ...state,
        transactionPaymentReasons: {
          list: action.payload.list
        }
      };
    case TRANSACTION_STATUS_LOOKUP_RESPONSE:
      return {
        ...state,
        transactionStatus: {
          list: action.payload.list
        }
      };
    case ROLES_LOOKUP_RESPONSE:
      return {
        ...state,
        roles: {
          list: action.payload.list
        }
      };
    case PRICING_PLANS_LOOKUP_RESPONSE:
      return {
        ...state,
        pricingPlans: {
          list: action.payload.list
        }
      };
    default:
      return state;
  }
};

export default lookups;
